import forbidden from './forbidden/index.tsx';
import genericError from './generic-error/index.tsx';
import serverError from './server-error/index.tsx';
import unauthorized from './unauthorized/index.tsx';

const errorConfigurations = {
	forbidden,
	genericError,
	serverError,
	unauthorized,
};

export default errorConfigurations;
